import script from "./grid-head.vue?vue&type=script&setup=true&lang=ts"
export * from "./grid-head.vue?vue&type=script&setup=true&lang=ts"

import "./grid-head.vue?vue&type=style&index=0&id=2ebfb87b&lang=postcss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ebfb87b"]])

export default __exports__